import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getTopAgentsByGroup as getTopAgentsService} from "services/modules/soc/agent";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Card, CardContent, Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";


const TopAgentsGraph = (props) => {
  // Props
  const { endDate, startDate } = props;
  // Redux selectors
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  // State variables
  const [empty, setEmpty] = useState(false);
  
  // fetches top agents within given time frame
  useEffect(() => {
    const fetchAndRenderChart = async () => {
      try {
        if (
          selectedCompanyContainer?.soc_env &&
          selectedCompanyContainer?.soc_group &&
          endDate &&
          startDate
        ) {
          const response = await getTopAgentsService({
            soc_env: selectedCompanyContainer?.soc_env,
            group: selectedCompanyContainer?.soc_group,
            end: endDate,
            start: startDate,
          });

          if (response?.data) {
            const buckets = response.data;
            setEmpty(buckets.length===0)
            const chartData = buckets.map((bucket) => ({
              label: bucket.key,
              value: bucket.doc_count,
            }));
            renderChart(chartData, response.data.length);
          }
        }
      } catch (error) {
        console.error("Error fetching FIM graph details:", error);
        setEmpty(true);
      }
    };

    fetchAndRenderChart();
    return () => {
      am4core.disposeAllCharts();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyContainer?.soc_env, selectedCompanyContainer?.soc_group, endDate,startDate,empty]);

  const renderChart = (data, total) => {
    am4core.useTheme(am4themes_animated);

    const chart = am4core.create("chartdiv", am4charts.PieChart3D);
    chart.hiddenState.properties.opacity = 0;

    chart.data = data.map((item) => ({
      label: item.label,
      value: item.value,
      percentage: ((item.value / total) * 100).toFixed(2) + "%",
    }));

    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fontSize = 13;
    chart.legend.labels.template.fill = am4core.color("#151515");
    chart.legend.labels.template.fontWeight = "bold";
    chart.legend.position = "right";
    chart.legend.align = "center";
    chart.legend.labels.template.maxWidth = 150;
    chart.legend.labels.template.wrap = true;
    chart.legend.labels.template.wordWrap = "break-word";

    const series = chart.series.push(new am4charts.PieSeries3D());
    series.dataFields.value = "value";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;
  };

  return (
    <Card sx={{ margin: "10px", height: "450px" }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <div className="dailogBox">
            <FontAwesomeIcon icon={faFileAlt} className="soc-icon" />
            <Typography variant="h6">Top Agents Details</Typography>
          </div>
        </Box>
        {!empty && <div id="chartdiv" className="soc-graph-container"></div>}
        {empty && (
          <div className="soc-graph-container">
          <div
           className="blur-effect"
          >
            No Details Found
          </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TopAgentsGraph;
